import { Component, Input, OnInit } from '@angular/core';
import { ApiConnectorService } from '../../../___LOGIC/__api/api-connector.service';
import { RequirementService } from '../../../___LOGIC/__requirements/requirement.service';

@Component({
  selector: 'app-requirement-detail',
  templateUrl: './requirement-detail.component.html',
  styleUrls: ['./requirement-detail.component.css']
})
export class RequirementDetailComponent implements OnInit {

  @Input() requirementDetails;
  reqSteps = [];

  newRequisite = {
    "order": "",
    "type": "",
    "title": "",
    "description": "",
    "steps": [
      {
        "id": "",
        "step": "",
        "progress": "",
        "form": [],
        "description": "",
        "document": "",
        "checklist": [
          { task: "", completed: false, dateCompleted: null }
        ]
      }
    ],
  };
  
  constructor(private requisitesService: RequirementService,private apiConnector: ApiConnectorService) { 
    /* if(!this.details){
      this.details = this.requisitesService.getCurrentRequisite();
    } */
  }

  ngOnInit(): void {
    if(this.requirementDetails){
      this.getSteps();
    }
  }

  getSteps(){
    this.apiConnector.newApiGetRequest('getStepsForChecklistItem',this.requirementDetails.id,null,null,null).subscribe(
      (response) => {
        this.reqSteps = response.records;
      },
      (error) => {
        debugger
       /*  this.guiFlow.reportError(error,'onboarding-page'); */
      }
    );
  }

}
